import React from "react";
import { useTranslation } from "react-i18next";
import PageShell from "../components/PageShell";

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation();
  const sections = t("privacy.sections", { returnObjects: true });

  return (
    <PageShell title={t("privacy.pageTitle")} mainClass="legal">
      <article className="wrap">
        <h1>{t("privacy.title")}</h1>
        <p className="meta">{t("privacy.updated")}</p>
        <p>{t("privacy.intro")}</p>

        {sections.map((section) => (
          <section key={section.title}>
            <h2>{section.title}</h2>
            {section.intro && <p>{section.intro}</p>}
            {section.bullets && (
              <ul>
                {section.bullets.map((bullet) => (
                  <li key={bullet.text}>
                    {bullet.label && (
                      <strong>
                        {bullet.label}{i18n.resolvedLanguage === "zh-HK" ? "：" : ": "}
                      </strong>
                    )}
                    {bullet.text}
                  </li>
                ))}
              </ul>
            )}
            {section.body && <p>{section.body}</p>}
            {section.contact && (
              <p>
                <strong>Virpluz</strong>
                <br />
                {t("privacy.emailLabel")} <a href="mailto:info@virpluz.io">info@virpluz.io</a>
                <br />
                {t("privacy.locationLine")}
              </p>
            )}
          </section>
        ))}
      </article>
    </PageShell>
  );
};

export default PrivacyPolicy;
